<ng-container
  *ngIf="{
    linkCollectionComponentType: linkCollectionComponentType$ | async,
    componentData: cmsComponent.data$ | async
  } as observables"
>
  <ng-container *ngIf="observables.linkCollectionComponentType === 'SocialLinkComponent'; else alphabeticalLinksTemplate">
    <div class="link-collection-social" [ngClass]="observables.componentData?.styleClasses">
      <p class="social-links-heading">{{ 'content.socialSharing_heading' | cxTranslate }}</p>
      <ng-container *ngFor="let linkId of observables.componentData?.links?.split(' ')">
        <ng-container
          [cxComponentWrapper]="{
            flexType: observables.linkCollectionComponentType,
            typeCode: observables.linkCollectionComponentType,
            uid: linkId
          }"
        ></ng-container>
      </ng-container>
    </div>
  </ng-container>

  <ng-template #alphabeticalLinksTemplate>
    <ng-container
      [cxComponentWrapper]="{
        flexType: 'AlphabeticalLinkContainerComponent',
        typeCode: 'AlphabeticalLinkContainerComponent',
        uid: observables.componentData?.uid
      }"
    ></ng-container>
  </ng-template>
</ng-container>
